import revive_payload_client_4sVQNw7RlN from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/wdd/wdd/frontend/ubs/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_AUP22rrBAc from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import errorHandler_client_gLLz53Pu7V from "/home/runner/work/wdd/wdd/frontend/shared/plugins/errorHandler.client.ts";
import lifecycle_client_uGCXBOfp9m from "/home/runner/work/wdd/wdd/frontend/ubs/plugins/lifecycle.client.ts";
import qr_client_cRxYHX1dw4 from "/home/runner/work/wdd/wdd/frontend/ubs/plugins/qr.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_AUP22rrBAc,
  errorHandler_client_gLLz53Pu7V,
  lifecycle_client_uGCXBOfp9m,
  qr_client_cRxYHX1dw4
]